(function () {
  const drawer = document.getElementById("nv-cart-drawer");
  const overlay = document.getElementById("nv-cart-overlay");
  const body = document.getElementById("nv-cart-drawer-body");
  const footer = document.getElementById("nv-cart-drawer-footer");
  const subtotalEl = document.getElementById("nv-cart-subtotal");

  if (!drawer || !overlay || !body || !footer || !subtotalEl) return;

  /* ===================================================
     OPEN / CLOSE
  ======================================================*/

  const open = () => {
    drawer.hidden = false;
    overlay.hidden = false;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.documentElement.style.overflow = "hidden";
    renderCart();
  };

  const close = () => {
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
    setTimeout(() => {
      drawer.hidden = true;
      overlay.hidden = true;
    }, 250);
  };

  /* ===================================================
     FETCH + HELPERS
  ======================================================*/

  async function fetchCart() {
    const res = await fetch("/cart.js");
    return res.json();
  }

  function money(cents) {
    return (cents / 100).toLocaleString("en-GB", {
      style: "currency",
      currency: "GBP",
    });
  }

  async function changeLine(line, quantity) {
    await fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ line, quantity }),
    });
    renderCart();
  }

  /* ===================================================
     RENDER CART
  ======================================================*/

  async function renderCart() {
    body.innerHTML = `<div class="nv-cart-drawer__loading">Loading cart…</div>`;
    const cart = await fetchCart();

    // UPSSELLS
    const last = cart.items[cart.items.length - 1];
    if (last && last.product_id) loadUpsells(last.product_id);

    if (cart.item_count === 0) {
      body.innerHTML = `
        <div class="nv-cart-drawer__empty">
          <p>Your cart is currently empty.</p>
          <a class="nv-cart-btn nv-cart-btn--green" href="/collections/all">Shop now</a>
        </div>
      `;
      footer.hidden = true;
      return;
    }

    const itemsHtml = cart.items
      .map((item, i) => {
        const img = item.image
          ? `<img src="${item.image}&width=150" width="72" height="72" alt="${item.product_title}">`
          : "";

        const variant =
          item.variant_title && item.variant_title !== "Default Title"
            ? `<div class="nv-cart-item__variant">${item.variant_title}</div>`
            : "";

        return `
          <div class="nv-cart-item" data-line="${i + 1}">
            <div class="nv-cart-item__img">${img}</div>
            <div class="nv-cart-item__info">
              <a class="nv-cart-item__title" href="${item.url}">${item.product_title}</a>
              ${variant}
              <div class="nv-cart-item__qty">
                <button type="button" data-qty="-1">−</button>
                <input type="number" min="1" value="${item.quantity}" />
                <button type="button" data-qty="1">+</button>
              </div>
              <a href="#" class="nv-cart-item__remove">Remove</a>
            </div>
            <div class="nv-cart-item__price">${money(item.final_line_price)}</div>
          </div>
        `;
      })
      .join("");

    body.innerHTML = itemsHtml;
    subtotalEl.textContent = money(cart.total_price);
    footer.hidden = false;

    /* ============================
       FREE SHIPPING BAR UPDATE
    ============================ */
    const freeShippingBox = document.getElementById("nv-free-shipping");
    const text = document.getElementById("nv-free-shipping-text");
    const bar = document.getElementById("nv-free-shipping-progress");
    const threshold = 2000; // £20 in cents
    const subtotal = cart.total_price;

    freeShippingBox.hidden = false;

    if (subtotal >= threshold) {
      text.innerText = "You’ve unlocked FREE Tracked 24 Delivery!";
      bar.style.width = "100%";
    } else {
      const remaining = (threshold - subtotal) / 100;
      text.innerText = `Spend £${remaining.toFixed(2)} more for FREE Tracked Delivery`;
      bar.style.width = ((subtotal / threshold) * 100).toFixed(1) + "%";
    }

    /* ============================
       QTY + REMOVE BINDINGS
    ============================ */
    body.querySelectorAll(".nv-cart-item").forEach((row) => {
      const line = Number(row.dataset.line);
      const input = row.querySelector("input");

      row.querySelectorAll("button[data-qty]").forEach((btn) => {
        btn.addEventListener("click", () => {
          const next = Math.max(1, Number(input.value) + Number(btn.dataset.qty));
          changeLine(line, next);
        });
      });

      input.addEventListener("change", () => {
        const next = Math.max(1, Number(input.value));
        changeLine(line, next);
      });

      row.querySelector(".nv-cart-item__remove").addEventListener("click", (e) => {
        e.preventDefault();
        changeLine(line, 0);
      });
    });
  }

  /* ===================================================
     UPSSELLS
  ======================================================*/

  async function loadUpsells(lastProductId) {
    const box = document.getElementById("nv-cart-upsells");
    const items = document.getElementById("nv-cart-upsells-items");

    const res = await fetch(`/recommendations/products.json?product_id=${lastProductId}&limit=4`);
    const data = await res.json();

    if (!data.products.length) {
      box.hidden = true;
      return;
    }

    box.hidden = false;

    items.innerHTML = data.products
      .map((p) => {
        const img = p.featured_image ? `${p.featured_image}&width=200` : "";
        return `
          <div class="nv-cart-upsell">
            <img src="${img}" alt="${p.title}">
            <div>
              <a href="${p.url}" class="nv-cart-upsell__title">${p.title}</a>
              <div class="nv-cart-upsell__price">${money(p.price)}</div>
              <button class="nv-cart-upsell__btn" data-upsell-add="${p.variants[0].id}">
                Add to cart
              </button>
            </div>
          </div>
        `;
      })
      .join("");

    items.querySelectorAll("[data-upsell-add]").forEach((btn) => {
      btn.addEventListener("click", async () => {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: btn.dataset.upsellAdd, quantity: 1 }),
        });
        renderCart();
      });
    });
  }

  /* ===================================================
     INTERCEPT ADD-TO-CART (FIXES REDIRECT)
  ======================================================*/

  document.addEventListener("submit", async (e) => {
    if (!e.target.matches('form[action="/cart/add"]')) return;

    e.preventDefault();

    const formData = new FormData(e.target);
    await fetch("/cart/add.js", {
      method: "POST",
      body: formData,
    });

    open();
  });

  /* ===================================================
     MANUAL OPEN/CLOSE
  ======================================================*/

  document.addEventListener("click", (e) => {
    const trigger = e.target.closest("[data-nv-cart-open]");
    if (trigger) {
      e.preventDefault();
      open();
    }
  });

  drawer.querySelector(".nv-cart-drawer__close").addEventListener("click", close);
  overlay.addEventListener("click", close);
  document.addEventListener("keydown", (e) => e.key === "Escape" && close());
})();
